module.exports = __webpack_public_path__ + "img/logo-brasil-io.9ece39c9.svg";